import { Box } from "@mui/material";
import { useHospitalData } from "../../../../contexts/HospitalDataProvider";
import { useRequestOrigins } from "../../../../hooks/useRequestOrigins";
import type { OpenShiftRequest, ReplaceShiftRequest } from "../../../../utils/models";
import { RequestItem } from "../../../RequestData/RequestsTab/RequestItem";
import { useRequestItemActions } from "../../../RequestData/RequestsTab/useRequestItemActions";

interface IProps {
	requests: OpenShiftRequest[] | ReplaceShiftRequest[];
}

export const PostedShiftsList = ({ requests }: IProps) => {
	const { handlers, dialogs } = useRequestItemActions();
	const { chosenDepartment } = useHospitalData();
	const origins = useRequestOrigins(chosenDepartment.department_id, requests);

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
			{requests.map((request: OpenShiftRequest | ReplaceShiftRequest) => (
				<RequestItem
					key={request.id}
					request={request}
					onDelete={handlers.onDelete}
					onBroadcast={handlers.onBroadcast}
					onEditNeededNurses={handlers.onEditNeededNurses}
					onShowAll={handlers.onShowAll}
					onTimeChange={handlers.onTimeChange}
					origins={origins.byRequestId.get(request.id) ?? null}
				/>
			))}
			{dialogs}
		</Box>
	);
};
